webpackJsonp([1],{

/***/ "01t/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1EGV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "28y1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-1.5815dcb.jpg";

/***/ }),

/***/ "3xKi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "72fJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8KlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center error"},[_c('i',{staticClass:"material-icons"},[_vm._v("remove_circle")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('label.emailVerification')))]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t('label.emailVerificationError'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12 text-right"},[_c('p',[_c('router-link',{staticClass:"link-underline",attrs:{"to":"/"}},[_vm._v("\n            "+_vm._s(_vm.$t('label.backLogin'))+"\n          ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bsso":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CuRo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EN1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__("XLHc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd00548_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__("f+v1");
function injectStyle (ssrContext) {
  __webpack_require__("hzjy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cd00548"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd00548_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F7L6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register'
});

/***/ }),

/***/ "H91P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Noactive_vue__ = __webpack_require__("OM3T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_366e68f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Noactive_vue__ = __webpack_require__("lah2");
function injectStyle (ssrContext) {
  __webpack_require__("1EGV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-366e68f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Noactive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_366e68f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Noactive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Im01":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JDOB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-3.715747f.jpg";

/***/ }),

/***/ "JGvJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/beebee.0f2fc80.png";

/***/ }),

/***/ "JJT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register',
  data: function data() {
    return {
      first_name: null,
      last_name: null,
      mail: '',
      username: '',
      password: '',
      password_confirm: '',
      error: '',
      step1: true,
      redirectUrl: null,
      running: false,
      organizationLegal: {
        organization_term_options: {
          data: []
        },
        organization_consensi: {
          data: {
            field_label: null,
            description: null,
            field_legal: null
          }
        }
      }
    };
  },

  created: function created() {
    var self = this;

    if (window.location.protocol !== 'https:' && "production" !== 'development') {
      window.location = location.href.replace('http://', 'https://');
    }

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/organizations/open').then(function (response) {
      if (response && response.data && response.data.data && response.data.data.relationships && response.data.data.relationships.gdpr) {
        if (!response.data.data.relationships.gdpr.organization_consensi.data) {
          response.data.data.relationships.gdpr.organization_consensi.data = {
            field_label: null,
            description: null,
            field_legal: null
          };
        }

        if (!response.data.data.relationships.gdpr.organization_term_options) {
          response.data.data.relationships.gdpr.organization_term_options = { data: [] };
        } else if (!response.data.data.relationships.gdpr.organization_term_options.data) {
          response.data.data.relationships.gdpr.organization_term_options.data = [];
        }

        if (!response.data.data.relationships.gdpr.organization_consensi) {
          response.data.data.relationships.gdpr.organization_consensi = { data: [] };
        } else if (!response.data.data.relationships.gdpr.organization_consensi.data) {
          response.data.data.relationships.gdpr.organization_consensi.data = [];
        }

        self.organizationLegal = response.data.data.relationships.gdpr;
      }
    });
  },


  methods: {
    register: function register() {
      var _this = this;

      var self = this;

      if (this.running) {
        return false;
      }

      var validateUsername = function validateUsername(str) {
        return !/[^a-z0-9+.]/g.test(str);
      };

      if (!this.first_name || !this.last_name || !this.mail || !this.username || !this.password) {
        this.error = this.$t('label.emptyField');
        return false;
      }

      if (!validateUsername(this.username)) {
        this.error = this.$t('label.invalidUsername');
        return false;
      }

      if (this.password !== this.password_confirm) {
        this.error = this.$t('label.passwordNotMatch');
        return false;
      }

      this.error = '';
      self.running = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/registration_complete', {
        'data': {
          'attributes': {
            'first_name': this.first_name,
            'last_name': this.last_name,
            'mail': this.mail,
            'username': this.username,
            'password': this.password,
            'gdpr': this.organizationLegal.organization_term_options.data
          }
        }
      }, {
        cache: false
      }).then(function (res) {
        self.running = false;
        console.log(res);
        if (res && res.data && res.data.url && res.data.access_token) {
          _this.$cookie.set('secure', res.data.access_token, {
            expires: parseFloat(res.data.access_token) / 60 / 60 / 24
          });
          self.redirectUrl = res.data.url;
        }
      }).catch(function (reason) {
        self.running = false;
        self.step1 = true;

        if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
          self.error = reason.response.data.errors[0].detail;
        } else {
          self.error = self.$t('label.signupError');
        }
      });
    }
  }
});

/***/ }),

/***/ "JwqI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-6.fa316ff.jpg";

/***/ }),

/***/ "LbEr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-2.4200921.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_592ab61c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qWQP");
function injectStyle (ssrContext) {
  __webpack_require__("zYJx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_592ab61c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MT2V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale__ = __webpack_require__("d0Uw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sentry_browser__ = __webpack_require__("AHhf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_integrations__ = __webpack_require__("M6om");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_5__sentry_browser__["a" /* init */]({
  dsn: 'https://83c7c7db2dcb4c24a6437b7abac60595@sentry.io/1522291',
  integrations: [new __WEBPACK_IMPORTED_MODULE_6__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */], attachProps: true })]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var VueCookie = __webpack_require__("K/Lq");
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueCookie);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var userLang = navigator.language || navigator.userLanguage;
userLang = userLang === 'en' ? 'en' : 'it';

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: userLang,
  messages: __WEBPACK_IMPORTED_MODULE_4__locale___default.a
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  i18n: i18n,

  mounted: function mounted() {
    if (window.fcWidget) {
      window.fcWidget.init({
        'token': '8cd4a741-d339-430f-91e9-075f0a56d52f',
        'host': 'https://wchat.freshchat.com'
      });
    }
  }
});

/***/ }),

/***/ "O9fs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'confirm',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      first_name: null,
      last_name: null,
      username: null,
      password: null,
      password_confirm: null,
      apiFirstName: null,
      apiLastName: null,
      mail: null,
      error: '',
      redirectUrl: null,
      googleRedirect: null,
      invalid: false,
      running: false,
      organizationLegal: {
        organization_term_options: {
          data: []
        },
        organization_consensi: {
          data: {
            field_label: null,
            description: null,
            field_legal: null
          }
        }
      }
    };
  },
  created: function created() {
    var self = this;

    var token = this.token;
    if (token) {
      this.googleRedirect = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/auth/set_google?contact_id=' + this.token;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/registration/confirm/' + token).then(function (res) {
        console.log(res);

        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.mail) {
          self.mail = res.data.data.user.mail;
        }
        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.first_name) {
          self.apiFirstName = res.data.data.user.first_name;
        }
        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.last_name) {
          self.apiLastName = res.data.data.user.last_name;
        }

        if (window.fcWidget) {
          window.fcWidget.on('widget:loaded', function (resp) {
            console.log('distruggo e ricarico widget');
            window.fcWidget.destroy();

            setTimeout(function () {
              console.log('window.fcWidget.init ' + res.data.data.user.organization + '-' + res.data.data.user.id);
              window.fcWidget.init({
                'token': '8cd4a741-d339-430f-91e9-075f0a56d52f',
                'host': 'https://wchat.freshchat.com',
                'siteId': res.data.data.user.organization,
                'externalId': res.data.data.user.organization + '-' + res.data.data.user.id,
                'restoreId': res.data.data.user.fresh_restore_id
              });
            }, 500);
          });
        }
      }).catch(function (reason) {
        self.invalid = true;
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/organizations/open').then(function (response) {
        if (response && response.data && response.data.data && response.data.data.relationships && response.data.data.relationships.gdpr) {
          if (!response.data.data.relationships.gdpr.organization_consensi.data) {
            response.data.data.relationships.gdpr.organization_consensi.data = {
              field_label: null,
              description: null,
              field_legal: null
            };
          }

          if (!response.data.data.relationships.gdpr.organization_term_options) {
            response.data.data.relationships.gdpr.organization_term_options = { data: [] };
          } else if (!response.data.data.relationships.gdpr.organization_term_options.data) {
            response.data.data.relationships.gdpr.organization_term_options.data = [];
          }

          if (!response.data.data.relationships.gdpr.organization_consensi) {
            response.data.data.relationships.gdpr.organization_consensi = { data: [] };
          } else if (!response.data.data.relationships.gdpr.organization_consensi.data) {
            response.data.data.relationships.gdpr.organization_consensi.data = [];
          }

          self.organizationLegal = response.data.data.relationships.gdpr;
        }
      });
    }
  },

  methods: {
    confirmR: function confirmR() {
      var self = this;
      var token = this.token;

      if (this.running) {
        return false;
      }

      if (!this.password || !this.password_confirm || !this.username || !(this.first_name || this.apiFirstName) || !(this.last_name || this.apiLastName)) {
        this.error = this.$t('label.emptyField');
        return false;
      }

      var validateUsername = function validateUsername(str) {
        return !/[^a-z0-9+.]/g.test(str);
      };

      var validateEmail = function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
      };

      if (!validateEmail(this.mail)) {
        this.error = this.$t('label.invalidMail');
        return false;
      }

      if (!validateUsername(this.username)) {
        this.error = this.$t('label.invalidUsername');
        return false;
      }

      if (this.password !== this.password_confirm) {
        this.error = this.$t('label.passwordNotMatch');
        return false;
      }

      this.error = '';
      self.running = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/registration/' + token, {
        'data': {
          'attributes': {
            'first_name': this.apiFirstName ? this.apiFirstName : this.first_name,
            'last_name': this.apiLastName ? this.apiLastName : this.last_name,
            'password': this.password,
            'username': this.username,
            'gdpr': self.organizationLegal.organization_term_options.data
          }
        }
      }, {
        cache: false
      }).then(function (res) {
        self.running = false;
        console.log(res);
        if (res && res.data && res.data.url && res.data.access_token) {
          self.$cookie.set('secure', res.data.access_token, {
            expires: parseFloat(res.data.access_token) / 60 / 60 / 24
          });

          if (window.fcWidget) {
            window.fcWidget.user.setProperties({
              'id': res.data.id,
              'firstName': res.data.first_name,
              'lastName': res.data.last_name,
              'email': res.data.mail,
              'Organization admin': res.data.organization_admin,
              'Organization name': res.data.organization,
              'Organization Product': res.data.redirect === 'clinic' ? 'Beebeehealth' : 'Beebeeboard',
              'Beebeeboard URI': 'https://' + res.data.organization + '.beebeeboard.com',
              'registrazione': 'Step 2: Dati completati'
            });

            window.fcWidget.track('registered-user');
          }

          self.redirectUrl = res.data.url;
        }
      }).catch(function (reason) {
        self.running = false;
        if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
          self.error = reason.response.data.errors[0].detail;
        } else {
          self.error = self.$t('label.signupError');
        }
      });
    }
  }
});

/***/ }),

/***/ "OM3T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recover',
  data: function data() {
    return {
      mail: '',
      error: '',
      success: false,
      running: false
    };
  },
  created: function created() {
    var self = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/organizations/open').then(function (response) {
      if (response && response.data && response.data.data && response.data.data.attributes.active && response.data.data.attributes.active) {
        self.$router.push('/');
      }
    });
  },

  methods: {
    recover: function recover() {
      var self = this;

      if (this.running) {
        return false;
      }

      this.error = '';
      self.running = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/resend_registration', {}, {
        cache: false
      }).then(function (response) {
        self.running = false;
        console.log(response);
        self.success = true;
      }).catch(function (reason) {
        self.running = false;
        if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
          self.error = reason.response.data.errors[0].detail;
        } else {
          self.error = self.$t('label.errorResendMail');
        }
      });
    }
  }
});

/***/ }),

/***/ "OpgM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-4.3f534d0.jpg";

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASEURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAURL; });
// var domain = location.hostname.split('.').shift()
var baseUrl = 'https://' + location.hostname;
// var baseUrl = `https://${domain}.beebeeboard.com`

if (false) {
  baseUrl = 'https://test.beebeeboard.com';
}

var BASEURL = baseUrl;
var DATAURL = 'https://data.beebeeboard.com';

/***/ }),

/***/ "T5fO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyError_vue__ = __webpack_require__("sx8+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638bbe2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyError_vue__ = __webpack_require__("8KlF");
function injectStyle (ssrContext) {
  __webpack_require__("Bsso")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-638bbe2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638bbe2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TRFP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-3.3568423.jpg";

/***/ }),

/***/ "TkTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-x grid-margin-x grid-padding-x align-center"},[_c('div',{staticClass:"medium-12 cell"},[_c('form',{staticClass:"form-horizontal new-lg-form",on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell medium-9 small-12"},[_c('a',{staticClass:"abcRioButton abcRioButtonBlue",attrs:{"href":"/api/auth/google"}},[_c('div',{staticClass:"abcRioButtonContentWrapper"},[_c('div',{staticClass:"abcRioButtonIcon"},[_c('div',{staticClass:"abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"},[_c('svg',{staticClass:"abcRioButtonSvg",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"18px","height":"18px","viewBox":"0 0 48 48"}},[_c('g',[_c('path',{attrs:{"fill":"#EA4335","d":"M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"}}),_c('path',{attrs:{"fill":"#4285F4","d":"M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"}}),_c('path',{attrs:{"fill":"#FBBC05","d":"M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"}}),_c('path',{attrs:{"fill":"#34A853","d":"M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h48v48H0z"}})])])])]),_c('span',{staticClass:"abcRioButtonContents"},[_c('span',{attrs:{"id":"not_signed_injysz01as6q36"}},[_vm._v(_vm._s(_vm.$t('label.loginGoogle')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"or-divider"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.$t('label.or'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('input',{attrs:{"type":"text","name":"username","id":"username","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.username'),"disabled":_vm.showAuthcode}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('input',{ref:"input",staticClass:"password",attrs:{"name":"password","id":"password","type":"password","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.password'),"disabled":_vm.showAuthcode}}),_vm._v(" "),_c('span',{staticClass:"unmask material-icons",class:_vm.showPwd ? 'off' : '',attrs:{"title":"Visualizza/nascondi password"},on:{"click":_vm.mask}})])]),_vm._v(" "),(_vm.showAuthcode)?_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('input',{attrs:{"type":"text","name":"authcode","id":"authcode","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.secure_code')}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('span',{staticClass:"messageError beebeeLabel"},[_vm._v(_vm._s(_vm.error))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12 medium-6"},[_c('button',{staticClass:"button button-default expanded hovering ld-over",class:_vm.running ? 'running' : '',attrs:{"type":"submit"}},[_vm._v("\n                "+_vm._s(_vm.$t('label.login'))+"\n                "),_c('div',{staticClass:"ld ld-ball ld-flip"})])]),_vm._v(" "),_c('div',{staticClass:"cell small-12 medium-6 text-right sideButton"},[_c('router-link',{staticClass:"link-underline",attrs:{"to":"recover"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.forgotPassword'))+"\n            ")])],1)])]),_vm._v(" "),(_vm.$parent.openRegistration)?_c('div',{staticClass:"loginOption text-right"},[_c('div',{staticClass:"text-right"},[_vm._v("\n        "+_vm._s(_vm.$t('label.notHaveAccount'))+" \n        "),_c('router-link',{staticClass:"link-underline",attrs:{"to":"register"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.signUp'))+"\n        ")]),_vm._v(" "),_c('br'),_vm._v("\n        "+_vm._s(_vm.$t('label.lessThenMinute'))+"\n      ")],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V0aP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recover',
  data: function data() {
    return {
      mail: '',
      error: '',
      success: false,
      running: false
    };
  },
  created: function created() {
    if (this.$route.query.mail) {
      this.mail = this.$route.query.mail;
    }
  },

  methods: {
    recover: function recover() {
      var self = this;

      if (this.running) {
        return false;
      }

      if (!this.mail) {
        this.error = this.$t('label.emptyField');
        return false;
      }

      this.error = '';
      self.running = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/users/forgot?mail=' + this.mail, {
        cache: false
      }).then(function (response) {
        self.running = false;
        console.log(response);
        self.success = true;
      }).catch(function (reason) {
        self.running = false;
        if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
          self.error = reason.response.data.errors[0].detail;
        } else {
          self.error = self.$t('label.recoverPasswordError');
        }
      });
    }
  }
});

/***/ }),

/***/ "XG+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__ = __webpack_require__("O9fs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8448ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__ = __webpack_require__("y8CW");
function injectStyle (ssrContext) {
  __webpack_require__("3xKi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c8448ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c8448ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XLHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reset',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      password: '',
      password_confirm: '',
      mail: null,
      error: '',
      redirectUrl: null,
      invalid: false,
      running: false
    };
  },
  created: function created() {
    var self = this;

    var token = this.token;
    if (token) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/reset/' + token).then(function (res) {
        console.log(res.data);
        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.id) {
          console.log(res.data.data.user.mail);
          self.mail = res.data.data.user.mail;
        }
      }).catch(function (reason) {
        self.invalid = true;
      });
    }
  },

  methods: {
    resetPwd: function resetPwd() {
      var _this = this;

      var self = this;
      var token = this.token;

      if (this.running) {
        return false;
      }

      if (this.password === '' || this.password_confirm === '') {
        this.error = this.$t('label.emptyField');
        return false;
      }

      if (this.password !== this.password_confirm) {
        this.error = this.$t('label.passwordNotMatch');
        return false;
      }

      this.error = '';
      self.running = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/reset/' + token, {
        'data': {
          'attributes': {
            'password': this.password
          }
        }
      }, {
        cache: false
      }).then(function (res) {
        self.running = false;
        console.log(res);

        if (res && res.data && res.data.url && res.data.access_token) {
          _this.$cookie.set('secure', res.data.access_token, {
            expires: parseFloat(res.data.access_token) / 60 / 60 / 24
          });
          self.redirectUrl = res.data.url;
        } else {
          self.running = false;
          if (typeof res.data.responseJSON.errors[0].detail !== 'undefined' && res.data.responseJSON.errors[0].detail) {
            self.error = res.data.responseJSON.errors[0].detail;
          }
        }
      }).catch(function (reason) {
        self.running = false;
        if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
          self.error = reason.response.data.errors[0].detail;
        } else {
          self.error = self.$t('label.resetError');
        }
      });
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Register__ = __webpack_require__("dIqY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Recover__ = __webpack_require__("exX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Reset__ = __webpack_require__("EN1E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Confirm__ = __webpack_require__("XG+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VerifySuccess__ = __webpack_require__("xTTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VerifyError__ = __webpack_require__("T5fO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Noactive__ = __webpack_require__("H91P");












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */],
  props: function props(route) {
    return {
      redirect: route.query.r
    };
  }
}, {
  path: '/register',
  name: 'Register',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Register__["a" /* default */]
}, {
  path: '/recover',
  name: 'Recover',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Recover__["a" /* default */]
}, {
  path: '/confirm/:token',
  name: 'Confirm',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Confirm__["a" /* default */],
  props: true
}, {
  path: '/reset/:token',
  name: 'Reset',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Reset__["a" /* default */],
  props: true
}, {
  path: '/verify_success',
  name: 'VerifySuccess',
  component: __WEBPACK_IMPORTED_MODULE_7__components_VerifySuccess__["a" /* default */]
}, {
  path: '/verify_error',
  name: 'VerifyError',
  component: __WEBPACK_IMPORTED_MODULE_8__components_VerifyError__["a" /* default */]
}, {
  path: '/no_active',
  name: 'NoActive',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Noactive__["a" /* default */]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "bBvI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center confirm"},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('label.emailVerification')))]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t('label.emailVerificationSuccess'))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12 text-right"},[_c('p',[_c('router-link',{staticClass:"link-underline",attrs:{"to":"/"}},[_vm._v("\n            "+_vm._s(_vm.$t('label.backLogin'))+"\n          ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d0Uw":
/***/ (function(module, exports) {

module.exports = {
  en: {
    beebee: {
      slogan: 'Get the most from your work and dedicate more time to your customers',
      trynow: 'Try Now'
    },
    label: {
      username: 'Username',
      password: 'Password',
      secure_code: 'Codice di sicurezza',
      login: 'Log in',
      loginGoogle: 'Log in with Google',
      forgotPassword: 'Forgot password?',
      notHaveAccount: 'Don\'t have an account?',
      signUp: 'Sign up',
      mailSent: 'Mail sent',
      checkMailRecover: 'Check you inbox to recover your password',
      enterMailToSendInstro: 'We\'ll emai your instructions on how to reset you password',
      recoverPassword: 'Recover password',
      backLogin: 'Back to login',
      passwordNotMatch: 'Password not match',
      recoverPasswordError: 'Recover password error',
      signupError: 'Sign up error',
      resetError: 'Reset error',
      signupGoogle: 'Sign up with Google',
      or: 'OR',
      name: 'Name',
      confirmPassword: 'Confirm password',
      newPassword: 'New Password',
      continue: 'Continue',
      emptyField: 'Empty field',
      invalidMail: 'Invalid mail',
      invalidUsername: 'Invalid username, you can only use lowercase letters and numbers',
      emailVerification: 'Email verification',
      emailVerificationSuccess: 'Your email was verified. You can continue using Beebeeboard.',
      emailVerificationError: 'Your email was not verified. You can not continue using the application.',
      passwordChanged: 'Password changed',
      loginAt: 'Login at',
      resetPassword: 'Reset password',
      registrationCompleted: 'Registration completed',
      invalidSession: 'Invalid session',
      lessThenMinute: 'It takes less than a minute',
      alreadyAccount: 'If you already have an account',
      personalInfo: 'Personal informations',
      accountInfo: 'Account informations',
      changePassword: 'Change password',
      termsOfServices: 'Terms of services',
      privacyPolicy: 'Privacy policy',
      beebeeGDPR: 'We use Beebeeboard as our platform. By clicking to register from this page, you acknowledge that the information you provide will be transferred to Beebeeboard for processing in accordance with their',
      noActive: 'Organization not activated',
      resendActivatedMail: 'if you don\'t have received the registration mail we can send it to you again',
      resendActivatedMailButton: 'Send me a new mail',
      errorResendMail: 'Error sending mail',
      first_name: 'First name',
      last_name: 'Last name'
    }
  },
  it: {
    beebee: {
      slogan: 'Organizza il tuo lavoro e dedica più tempo ai tuoi clienti',
      trynow: 'Provalo subito'
    },
    label: {
      username: 'Nome utente',
      password: 'Password',
      login: 'Accedi',
      loginGoogle: 'Accedi con Google',
      forgotPassword: 'Recupera password?',
      notHaveAccount: 'Non hai un account?',
      signUp: 'Registrati',
      mailSent: 'Mail inviata',
      checkMailRecover: 'Controlla la tua mail per ripristinare la password',
      enterMailToSendInstro: 'Ti invieremo una mail con le istruzioni per reimpostare la tua password',
      recoverPassword: 'Ripristina password',
      backLogin: 'Torna al login',
      passwordNotMatch: 'Le Password non coincidono',
      recoverPasswordError: 'Errore nel recupero password',
      signupError: 'Error nella registrazione',
      resetError: 'Errore nel recupero password',
      signupGoogle: 'Registrati con Google',
      or: 'OPPURE',
      name: 'Nome',
      confirmPassword: 'Conferma password',
      newPassword: 'Nuova password',
      continue: 'Successivo',
      emptyField: 'Campi mancanti',
      invalidMail: 'Mail non valida',
      invalidUsername: 'Nome utente non valido, puoi usare solo lettere minuscole e numeri',
      emailVerification: 'Verifica mail',
      emailVerificationSuccess: 'La mail è stata verificata. Puoi continuare ad usare Beebeeboard.',
      emailVerificationError: 'La mail non è stata verificata. Non puoi continuare ad usare Beebeeboard.',
      passwordChanged: 'Password modificata',
      loginAt: 'Accedi subito',
      resetPassword: 'Recupera password',
      registrationCompleted: 'Registrazione completata',
      invalidSession: 'Sessione non valida',
      lessThenMinute: 'Ci vuole meno di un minuto',
      alreadyAccount: 'Se hai già un account',
      personalInfo: 'Informazioni personali',
      accountInfo: 'Informazioni sull\'account',
      changePassword: 'Cambia password',
      termsOfServices: 'Termini e condizioni',
      privacyPolicy: 'Normativa privacy',
      beebeeGDPR: 'Usiamo Beebeeboard come piattaforma di elaborazione dati. Facendo click per registrarti da questa pagina, acconsenti che le tue informazioni vengano trasferite a Beebeeboard per la loro elaborazione in conformità con la loro',
      noActive: 'Organizzazione non attiva',
      resendActivatedMail: 'Se non hai ricevuto la mail per completare la registrazione possiamo inviartela nuovamente',
      resendActivatedMailButton: 'Inviami una nuova mail',
      errorResendMail: 'Errore nell\'inviare la mail',
      first_name: 'Nome',
      last_name: 'Cognome'
    }
  }
};

/***/ }),

/***/ "dIqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("JJT7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f7024d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("farT");
function injectStyle (ssrContext) {
  __webpack_require__("72fJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32f7024d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f7024d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ditD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-2.cb2b822.jpg";

/***/ }),

/***/ "e0ax":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-1.70da764.jpg";

/***/ }),

/***/ "eoAq":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./active-1.jpg": "e0ax",
	"./active-2.jpg": "LbEr",
	"./active-3.jpg": "TRFP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eoAq";

/***/ }),

/***/ "exX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__ = __webpack_require__("V0aP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a06add0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__ = __webpack_require__("iwdy");
function injectStyle (ssrContext) {
  __webpack_require__("rmvi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a06add0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a06add0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f+v1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.redirectUrl)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center confirm"},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")]),_vm._v(" "),_c('h3',[_vm._v("\n              "+_vm._s(_vm.$t('label.passwordChanged'))+"\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t('label.loginAt'))+" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"link-underline",attrs:{"href":_vm.redirectUrl}},[_vm._v("\n                "+_vm._s(_vm.redirectUrl)+"\n              ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.redirectUrl)?_c('div',[(_vm.mail)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('h5',[_vm._v(_vm._s(_vm.$t('label.resetPassword')))]),_vm._v(" "),_c('h6',{staticClass:"mail-to"},[_vm._v("Email: "+_vm._s(_vm.mail))])])]):_vm._e(),_vm._v(" "),(_vm.mail)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.newPassword')},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.mail)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_confirm),expression:"password_confirm"}],attrs:{"type":"password","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.confirmPassword')},domProps:{"value":(_vm.password_confirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_confirm=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[(_vm.mail)?_c('div',{staticClass:"cell small-12"},[_c('span',{staticClass:"messageError beebeeLabel"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()]),_vm._v(" "),(_vm.mail)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12 medium-6"},[_c('button',{staticClass:"button button-default expanded hovering ld-over",class:_vm.running ? 'running' : '',attrs:{"type":"submit"},on:{"click":_vm.resetPwd}},[_vm._v("\n                "+_vm._s(_vm.$t('label.changePassword'))+"\n                "),_c('div',{staticClass:"ld ld-ball ld-flip"})])]),_vm._v(" "),_c('div',{staticClass:"cell small-12 medium-6 text-right sideButton"},[_c('router-link',{staticClass:"link-underline",attrs:{"to":"/"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.backLogin'))+"\n            ")])],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.invalid)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center"},[_c('h5',[_vm._v(_vm._s(_vm.$t('label.invalidSession')))])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "farT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.redirectUrl)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('h5',[_vm._v(_vm._s(_vm.$t('label.signUp')))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell medium-9 small-12"},[_c('a',{staticClass:"abcRioButton abcRioButtonBlue",attrs:{"href":"/api/auth/create_google"}},[_c('div',{staticClass:"abcRioButtonContentWrapper"},[_c('div',{staticClass:"abcRioButtonIcon"},[_c('div',{staticClass:"abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"},[_c('svg',{staticClass:"abcRioButtonSvg",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"18px","height":"18px","viewBox":"0 0 48 48"}},[_c('g',[_c('path',{attrs:{"fill":"#EA4335","d":"M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"}}),_c('path',{attrs:{"fill":"#4285F4","d":"M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"}}),_c('path',{attrs:{"fill":"#FBBC05","d":"M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"}}),_c('path',{attrs:{"fill":"#34A853","d":"M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h48v48H0z"}})])])])]),_c('span',{staticClass:"abcRioButtonContents"},[_c('span',{attrs:{"id":"not_signed_injysz01as6q36"}},[_vm._v(_vm._s(_vm.$t('label.signupGoogle')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"or-divider"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.$t('label.or'))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('h6',[_vm._v(_vm._s(_vm.$t('label.personalInfo')))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell sideButton"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.first_name),expression:"first_name"}],attrs:{"type":"text","required":"true","placeholder":_vm.$t('label.first_name')},domProps:{"value":(_vm.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.first_name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell sideButton"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.last_name),expression:"last_name"}],attrs:{"type":"text","required":"true","placeholder":_vm.$t('label.last_name')},domProps:{"value":(_vm.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.last_name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell sideButton"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mail),expression:"mail"}],attrs:{"type":"text","required":"true","placeholder":"Email"},domProps:{"value":(_vm.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('h6',[_vm._v(_vm._s(_vm.$t('label.accountInfo')))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.username')},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.password')},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_confirm),expression:"password_confirm"}],attrs:{"type":"password","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.confirmPassword')},domProps:{"value":(_vm.password_confirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_confirm=$event.target.value}}})])]),_vm._v(" "),(_vm.organizationLegal.organization_consensi.data.field_label)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('h6',[_vm._v(_vm._s(_vm.organizationLegal.organization_consensi.data.field_label))])])]):_vm._e(),_vm._v(" "),(_vm.organizationLegal.organization_consensi.data.description)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_vm._v("\n            "+_vm._s(_vm.organizationLegal.organization_consensi.data.description)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.organizationLegal.organization_term_options.data.length)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('ul',_vm._l((_vm.organizationLegal.organization_term_options.data),function(option){return _c('li',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.active),expression:"option.active"}],attrs:{"type":"checkbox","id":option.id},domProps:{"checked":Array.isArray(option.active)?_vm._i(option.active,null)>-1:(option.active)},on:{"change":function($event){var $$a=option.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(option, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(option, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(option, "active", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":option.id}},[_vm._v(_vm._s(option.name))])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.organizationLegal.organization_consensi.data.field_legal)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('div',{staticClass:"beebee-gdpr"},[_vm._v("\n                "+_vm._s(_vm.organizationLegal.organization_consensi.data.field_legal)+"\n            ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center align-middle"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cell medium-9 small-9"},[_c('div',{staticClass:"beebee-gdpr"},[_vm._v("\n              "+_vm._s(_vm.$t('label.beebeeGDPR'))+"\n              "),_c('a',{attrs:{"href":"https://beebeeboard.com/normativa-privacy","target":"_black"}},[_vm._v("\n                "+_vm._s(_vm.$t('label.privacyPolicy'))+"\n              ")]),_vm._v(" e \n              "),_c('a',{attrs:{"href":"https://beebeeboard.com/termini-e-condizioni","target":"_black"}},[_vm._v("\n                "+_vm._s(_vm.$t('label.termsOfServices'))+".\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('span',{staticClass:"messageError beebeeLabel"},[_vm._v(_vm._s(_vm.error))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell medium-6 small-12"},[_c('button',{staticClass:"button button-default expanded hovering ld-over",class:_vm.running ? 'running' : '',on:{"click":_vm.register}},[_vm._v("\n              "+_vm._s(_vm.$t('label.signUp'))+"\n              "),_c('div',{staticClass:"ld ld-ball ld-flip"})])]),_vm._v(" "),_c('div',{staticClass:"cell small-12 medium-6 text-right sideButton"},[_c('router-link',{staticClass:"link-underline",attrs:{"to":"/"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.backLogin'))+"\n            ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.redirectUrl)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center confirm"},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")]),_vm._v(" "),_c('h3',[_vm._v("\n              "+_vm._s(_vm.$t('label.registrationCompleted'))+"\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t('label.loginAt'))),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.redirectUrl}},[_vm._v("\n                "+_vm._s(_vm.redirectUrl)+"\n              ")])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell medium-3 small-3 text-center"},[_c('i',{staticClass:"material-icons beebee-gdpr-icon"},[_vm._v("verified_user")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hzjy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iwdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-horizontal new-lg-form",on:{"submit":function($event){$event.preventDefault();return _vm.recover($event)}}},[(_vm.success)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center confirm"},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('label.mailSent')))]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.$t('label.checkMailRecover'))+"\n              ")])])])]):_vm._e(),_vm._v(" "),(!_vm.success)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('label.recoverPassword')))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('label.enterMailToSendInstro')))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mail),expression:"mail"}],attrs:{"type":"text","required":"true","placeholder":"Email"},domProps:{"value":(_vm.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('span',{staticClass:"messageError beebeeLabel"},[_vm._v(_vm._s(_vm.error))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12 medium-6"},[_c('button',{staticClass:"button button-default expanded hovering ld-over",class:_vm.running ? 'running' : '',attrs:{"type":"submit"},on:{"click":_vm.recover}},[_vm._v("\n                "+_vm._s(_vm.$t('label.recoverPassword'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"cell small-12 medium-6 text-right sideButton"},[_c('router-link',{staticClass:"link-underline",attrs:{"to":"/"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.backLogin'))+"\n            ")])],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jXON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lah2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.success)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center confirm"},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")]),_vm._v(" "),_c('h3',[_vm._v("\n              "+_vm._s(_vm.$t('label.mailSent'))+"\n            ")])])])]):_vm._e(),_vm._v(" "),(!_vm.success)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('h5',[_vm._v(_vm._s(_vm.$t('label.noActive')))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('label.resendActivatedMail')))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('span',{staticClass:"messageError beebeeLabel"},[_vm._v(_vm._s(_vm.error))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-10"},[_c('button',{staticClass:"button button-default expanded hovering ld-over",class:_vm.running ? 'running' : '',attrs:{"type":"submit"},on:{"click":_vm.recover}},[_vm._v("\n                "+_vm._s(_vm.$t('label.resendActivatedMailButton'))+"\n              ")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      error: '',
      showPwd: false,
      running: false,
      showAuthcode: false
    };
  },
  props: {
    redirect: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'password'
    }
  },

  mounted: function mounted() {
    this.$refs.input.type = this.type;
  },
  created: function created() {
    var _this = this;

    var accessToken = this.$cookie.get('secure');
    var self = this;

    if (accessToken) {
      console.log('TOKEN PRESENTE');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/contacts/me', { headers: { Authorization: 'Bearer ' + accessToken } }).then(function (res) {
        if (res && res.data && res.data.data && res.data.data.relationships && res.data.data.relationships.role && res.data.data.relationships.role.data && res.data.data.relationships.role.data.id) {
          var roleId = res.data.data.relationships.role.data.id;
          var redirect = 'start';

          for (var i = 0; i < res.data.included.length; i++) {
            if (res.data.included[i].type === 'roles' && res.data.included[i].id === roleId && res.data.included[i].attributes.redirect_page) {
              redirect = res.data.included[i].attributes.redirect_page;
            }
          }

          if (redirect.substring(0, 4) === 'http') {
            window.location = redirect + accessToken;
          } else {
            if (_this.$route.query.r) {
              window.location = _this.$route.query.r;
            } else {
              window.location = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/' + redirect;
            }
          }
        } else {
          if (_this.$route.query.r) {
            window.location = _this.$route.query.r;
          } else {
            window.location = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/start';
          }
        }
      });
    }

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/v1/organizations/open').then(function (response) {
      if (!response.data.data.attributes.active) {
        self.$router.push('no_active');
      }
    });
  },


  methods: {
    login: function login() {
      var self = this;
      var username = document.getElementById('username').value;
      var password = document.getElementById('password').value;
      var authcode = this.showAuthcode ? document.getElementById('authcode').value : null;

      if (this.running) {
        return false;
      }

      if (!username || !password) {
        this.error = 'Empty field';
        return false;
      }

      this.error = '';
      this.running = true;

      var queryParams = 'grant_type=password&username=' + username + '&password=' + password;
      if (authcode) {
        queryParams += '&authcode=' + authcode;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/api/oauth/token', queryParams, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Basic YWJjMTIzOnNzaC1zZWNyZXQ='
        },
        cache: false
      }).then(function (response) {
        self.running = false;
        console.log(response);

        if (response && response.data && response.data.access_token) {
          response = response.data;

          self.$cookie.set('secure', response.access_token, {
            expires: parseFloat(response.expires_in) / 3600 + 'h'
          });

          if (self.redirect) {
            window.location = self.redirect;
            return true;
          }

          if (response.redirect) {
            if (response.redirect.substring(0, 4) === 'http') {
              window.location = response.redirect + response.access_token;
            } else {
              window.location = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/' + response.redirect;
            }
          } else {
            window.location = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* BASEURL */] + '/start/';
          }

          return true;
        } else if (response && response.data && response.data.authcode && response.data.authcode === 'required') {
          self.showAuthcode = true;
        } else {
          self.error = 'Login Error';
          password = '';
        }
      }).catch(function () {
        self.running = false;
        self.error = 'Login error';
        password = '';
      });
    },
    mask: function mask() {
      this.$refs.input.type = this.$refs.input.type === 'text' ? 'password' : 'text';
      this.showPwd = !this.showPwd;
    }
  }
});

/***/ }),

/***/ "qCP4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/active-5.71c7ebb.jpg";

/***/ }),

/***/ "qWQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background"},[_c('div',{staticClass:"backgroundImage",style:({ backgroundImage: ("url('" + _vm.organizationBackground + "')") })}),_vm._v(" "),_c('div',{staticClass:"background-overlay"})]),_vm._v(" "),_c('div',{staticClass:"header"},[_c('div',{staticClass:"headerNode text-secondary"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setLang('it')}}},[_vm._v("ITA")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setLang('en')}}},[_vm._v("ENG")])])]),_vm._v(" "),_c('div',{staticClass:"outer"},[_c('div',{staticClass:"middle"},[_c('div',{staticClass:"inner"},[_c('router-link',{staticClass:"text-center domainLogo",attrs:{"to":"/"}},[_c('div',{style:({ backgroundImage: ("url('" + _vm.organizationThumbnail + "')") })})]),_vm._v(" "),_c('h5',{staticClass:"domainName"},[_vm._v(_vm._s(_vm.organizationName))]),_vm._v(" "),_c('router-view')],1)])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footerNode text-secondary"},[_vm._m(0),_vm._v(" "),_c('a',{attrs:{"href":"https://beebeeboard.com/termini-e-condizioni","target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('label.termsOfServices'))+"\n      ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://beebeeboard.com/normativa-privacy","target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('label.privacyPolicy'))+"\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":"https://beebeeboard.com","target":"_blank"}},[_vm._v("Beebeeboard")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rmvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sx8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register'
});

/***/ }),

/***/ "wK7w":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./active-1.jpg": "28y1",
	"./active-2.jpg": "ditD",
	"./active-3.jpg": "JDOB",
	"./active-4.jpg": "OpgM",
	"./active-5.jpg": "qCP4",
	"./active-6.jpg": "JwqI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wK7w";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_foundation_min_css__ = __webpack_require__("MT2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_foundation_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_css_foundation_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_loading_css__ = __webpack_require__("01t/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_loading_btn_css__ = __webpack_require__("yKRw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_loading_btn_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_loading_btn_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_main_css__ = __webpack_require__("CuRo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("QmSG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  data: function data() {
    return {
      organizationThumbnail: null,
      organizationBackground: null,
      organizationName: '',
      openRegistration: false,
      organizationLegal: '',
      view: ''
    };
  },

  created: function created() {
    var self = this;

    if (window.location.protocol !== 'https:' && "production" !== 'development') {
      window.location = location.href.replace('http://', 'https://');
    }

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* BASEURL */] + '/api/v1/organizations/open').then(function (response) {
      self.openRegistration = response.data.data.attributes.new_registration;
      self.organizationName = response.data.data.attributes.name;
      self.organizationLegal = response.data.data.attributes.gdpr_legal;

      if (response.data.data.attributes.thumbnail_url) {
        self.organizationThumbnail = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* DATAURL */] + '/' + response.data.data.attributes.thumbnail_url + '-medium.jpeg';
      } else {
        self.organizationThumbnail = __webpack_require__("JGvJ");
      }

      if (response.data.data.attributes.copertina_url) {
        self.organizationBackground = __WEBPACK_IMPORTED_MODULE_5__config__["b" /* DATAURL */] + '/' + response.data.data.attributes.copertina_url;
      } else {
        if (response.data.data.attributes.redirect_url_admin === 'clinic') {
          var rand = Math.floor(Math.random() * 3 + 1);
          self.organizationBackground = __webpack_require__("eoAq")("./active-" + rand + '.jpg');
        } else {
          var _rand = Math.floor(Math.random() * 6 + 1);
          self.organizationBackground = __webpack_require__("wK7w")("./active-" + _rand + '.jpg');
        }
      }
    });
  },


  methods: {
    setLang: function setLang(lang) {
      this.$i18n.locale = lang;
    }
  }

});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5618542_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("TkTM");
function injectStyle (ssrContext) {
  __webpack_require__("Im01")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5618542"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5618542_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xTTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifySuccess_vue__ = __webpack_require__("F7L6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ada830f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifySuccess_vue__ = __webpack_require__("bBvI");
function injectStyle (ssrContext) {
  __webpack_require__("jXON")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ada830f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifySuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ada830f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifySuccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y8CW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.redirectUrl)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center confirm"},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('label.registrationCompleted')))]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t('label.loginAt'))),_c('br'),_vm._v(" "),_c('a',{staticClass:"link-underline",attrs:{"href":_vm.redirectUrl}},[_vm._v("\n                "+_vm._s(_vm.redirectUrl)+"\n              ")])])])])]):_vm._e(),_vm._v(" "),(!_vm.redirectUrl && _vm.mail)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('h3',[_vm._v(_vm._s(_vm.$t('label.signUp')))]),_vm._v(" "),_c('h6',{staticClass:"mail-to"},[_vm._v("Email: "+_vm._s(_vm.mail))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12 text-right"},[_c('div',{staticClass:"loginOption"},[_vm._v("\n            "+_vm._s(_vm.$t('label.signUp'))+", "+_vm._s(_vm.$t('label.lessThenMinute'))+"\n            "),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t('label.alreadyAccount'))+"\n            "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.login'))+"\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell medium-9 small-12"},[_c('a',{staticClass:"abcRioButton abcRioButtonBlue",attrs:{"href":_vm.googleRedirect}},[_c('div',{staticClass:"abcRioButtonContentWrapper"},[_c('div',{staticClass:"abcRioButtonIcon"},[_c('div',{staticClass:"abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"},[_c('svg',{staticClass:"abcRioButtonSvg",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"18px","height":"18px","viewBox":"0 0 48 48"}},[_c('g',[_c('path',{attrs:{"fill":"#EA4335","d":"M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"}}),_c('path',{attrs:{"fill":"#4285F4","d":"M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"}}),_c('path',{attrs:{"fill":"#FBBC05","d":"M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"}}),_c('path',{attrs:{"fill":"#34A853","d":"M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h48v48H0z"}})])])])]),_c('span',{staticClass:"abcRioButtonContents"},[_c('span',{attrs:{"id":"not_signed_injysz01as6q36"}},[_vm._v(_vm._s(_vm.$t('label.signupGoogle')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell medium-9 small-12 text-center"},[_c('div',{staticClass:"or-divider"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.$t('label.or'))+"\n                ")])])])]),_vm._v(" "),(!_vm.apiFirstName)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.first_name),expression:"first_name"}],attrs:{"type":"text","required":"true","placeholder":_vm.$t('label.first_name')},domProps:{"value":(_vm.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.first_name=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(!_vm.apiLastName)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.last_name),expression:"last_name"}],attrs:{"type":"text","required":"true","placeholder":_vm.$t('label.last_name')},domProps:{"value":(_vm.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.last_name=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.username')},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.password')},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_confirm),expression:"password_confirm"}],attrs:{"type":"password","required":"true","autocorrect":"off","autocapitalize":"off","spellcheck":"false","placeholder":_vm.$t('label.confirmPassword')},domProps:{"value":(_vm.password_confirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_confirm=$event.target.value}}})])]),_vm._v(" "),(_vm.organizationLegal.organization_consensi.data.field_label)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('h6',[_vm._v(_vm._s(_vm.organizationLegal.organization_consensi.data.field_label))])])]):_vm._e(),_vm._v(" "),(_vm.organizationLegal.organization_consensi.data.description)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_vm._v("\n              "+_vm._s(_vm.organizationLegal.organization_consensi.data.description)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.organizationLegal.organization_term_options.data.length)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('ul',_vm._l((_vm.organizationLegal.organization_term_options.data),function(option){return _c('li',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.active),expression:"option.active"}],attrs:{"type":"checkbox","id":option.id},domProps:{"checked":Array.isArray(option.active)?_vm._i(option.active,null)>-1:(option.active)},on:{"change":function($event){var $$a=option.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(option, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(option, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(option, "active", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":option.id}},[_vm._v(_vm._s(option.name))])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.organizationLegal.organization_consensi.data.field_legal)?_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('div',{staticClass:"beebee-gdpr"},[_vm._v("\n                  "+_vm._s(_vm.organizationLegal.organization_consensi.data.field_legal)+"\n              ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x align-center align-middle"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cell medium-9 small-9"},[_c('div',{staticClass:"beebee-gdpr"},[_vm._v("\n                "+_vm._s(_vm.$t('label.beebeeGDPR'))+"\n                "),_c('a',{attrs:{"href":"https://beebeeboard.com/normativa-privacy","target":"_black"}},[_vm._v("\n                  "+_vm._s(_vm.$t('label.privacyPolicy'))+"\n                ")]),_vm._v(" e \n                "),_c('a',{attrs:{"href":"https://beebeeboard.com/termini-e-condizioni","target":"_black"}},[_vm._v("\n                  "+_vm._s(_vm.$t('label.termsOfServices'))+".\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12"},[_c('span',{staticClass:"messageError beebeeLabel"},[_vm._v(_vm._s(_vm.error))])])]),_vm._v(" "),_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell medium-6 small-12"},[_c('button',{staticClass:"button button-default expanded hovering ld-over",class:_vm.running ? 'running' : '',on:{"click":_vm.confirmR}},[_vm._v("\n                "+_vm._s(_vm.$t('label.signUp'))+"\n                "),_c('div',{staticClass:"ld ld-ball ld-flip"})])])])]):_vm._e(),_vm._v(" "),(_vm.invalid)?_c('div',[_c('div',{staticClass:"grid-x grid-padding-x align-center"},[_c('div',{staticClass:"cell text-center"},[_c('h5',[_vm._v(_vm._s(_vm.$t('label.invalidSession')))])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell medium-3 small-3 text-center"},[_c('i',{staticClass:"material-icons beebee-gdpr-icon"},[_vm._v("verified_user")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yKRw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zYJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e46de8e0a4f69c3827ca.js